import { FC } from 'react';
import {
  FilterSection,
  ColumnDateFilter,
  ColumnMultiSelectFilter,
} from 'components/data-table';
import type { DevelopmentPaceScenarioFacets } from './types';
import { PACE_MODEL_LABELS } from './utils';
import styles from './development-pace-scenarios-filters.module.scss';

interface DevelopmentPaceScenariosFiltersProps {
  facets: DevelopmentPaceScenarioFacets | undefined;
}

const toOptions = (items: { id: string; value: string }[] | undefined) =>
  (items ?? []).map((item) => ({ value: item.id, label: item.value }));

const paceModelOptions = Object.entries(PACE_MODEL_LABELS).map(
  ([value, label]) => ({ value, label })
);

const DevelopmentPaceScenariosFilters: FC<
  DevelopmentPaceScenariosFiltersProps
> = ({ facets }) => {
  return (
    <div className={styles.filtersWrapper}>
      <FilterSection title="Date Filters">
        <ColumnDateFilter columnId="createdAt" label="Created Date" />
        <ColumnDateFilter columnId="updatedAt" label="Updated Date" />
      </FilterSection>

      <FilterSection title="Configuration Details">
        <ColumnMultiSelectFilter
          columnId="paceModel"
          label="Scheduling Model"
          options={paceModelOptions}
        />

        <ColumnMultiSelectFilter
          columnId="createdBy"
          label="Created By"
          options={toOptions(facets?.createdByOptions)}
        />
      </FilterSection>
    </div>
  );
};

export { DevelopmentPaceScenariosFilters };
